/* eslint-disable */
export default {
  start: '둘러보기',
  skip: '건너뛰기',
  next: '다음',
  finish: '완료',
} as const;

// @key: @#@"start"@#@ @source: @#@"Take a quick tour"@#@
// @key: @#@"skip"@#@ @source: @#@"Skip"@#@
// @key: @#@"next"@#@ @source: @#@"Next"@#@
// @key: @#@"finish"@#@ @source: @#@"Finish"@#@
